import React from 'react';
import { ArrowRightIcon, GiftIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { bonuses } from '../../data/bonuses';
export function Bonuses() {
  return <section className="bg-cream" data-id="element-123" data-mp="1clpod1fsit0d">
      <div className="mx-auto max-w-4xl px-3 py-14 sm:px-5 md:py-20" data-id="element-124" data-mp="18jkvw612w2fb">
        <div className="px-2" data-id="element-125" data-mp="18lff9fwpbmha">
          <SectionHeading title={<>And I'm giving you <em className="text-coral" data-id="element-127" data-mp="259bq045gjnkl">5 bonuses free</em></>} subtitle="Everything you need to put the system to work from day one." data-id="element-126" data-mp="259lf7piohqp8" />
        </div>

        <ol className="mt-10 space-y-6" data-id="element-128" data-mp="1w8dte6xcmic1">
          {bonuses.map(b => <li key={b.number} className="overflow-hidden rounded-3xl border border-navy/10 bg-white shadow-sm" data-id="element-129" data-mp="1rac9xkw0gh01">
              <div className="flex items-center justify-between gap-3 bg-navy px-5 py-3" data-id="element-130" data-mp="kujj66l7q548">
                <span className="flex items-center gap-2 text-sm font-black uppercase tracking-wider text-white" data-id="element-131" data-mp="fudwz5xppatj">
                  <GiftIcon className="h-4 w-4 text-sun" aria-hidden="true" data-id="element-132" data-mp="1eteyqhdnc8c4" />
                  Bonus #{b.number}
                </span>
                <span className="text-sm font-bold text-white/80" data-id="element-133" data-mp="1jrykagobvi3y">
                  Value: <s data-id="element-134" data-mp="15s70fzb4r7i1">{b.value}</s> <span className="ml-1 rounded-full bg-cta px-2 py-0.5 text-xs font-black uppercase text-white" data-id="element-135" data-mp="15sgq1ls9jcn7">Free</span>
                </span>
              </div>

              <div className="md:grid md:grid-cols-2 md:items-center" data-id="element-136" data-mp="w2x6sf0n1grt">
                <img src={b.image} alt={`${b.title} mockup`} className="block w-full bg-cream" loading="lazy" data-id="element-137" data-mp="10tvqzpoqyz0c" />
                <div className="p-5 sm:p-7" data-id="element-138" data-mp="n30qb0oejo7u">
                  <h3 className="font-display text-2xl font-bold leading-tight text-navy sm:text-[28px]" data-id="element-139" data-mp="n423baozaks7">{b.title}</h3>
                  <p className="mt-3 text-[17px] leading-relaxed text-muted" data-id="element-140" data-mp="r1ztoguhjcx6">{b.body}</p>

                  {b.flow.length > 0 && <ol className="mt-4 flex flex-wrap items-center gap-1.5" data-id="element-141" data-mp="i3xkhe0lldyt">
                      {b.flow.map((f, i) => <li key={f} className="flex items-center gap-1.5" data-id="element-142" data-mp="2jtd6tvft2t6c" data-mpi={i}>
                          <span className="rounded-lg bg-sun-soft px-2.5 py-1 text-sm font-extrabold text-navy" data-id="element-143" data-mp="2f1blzl4knu4p">{f}</span>
                          {i < b.flow.length - 1 && <ArrowRightIcon className="h-4 w-4 text-sun-dark" aria-hidden="true" data-id="element-144" data-mp="2b0hxoqn7wdba" />}
                        </li>)}
                    </ol>}

                  {b.items.length > 0 && <ul className="mt-4 flex flex-wrap gap-1.5" data-id="element-145" data-mp="2yq3ytjn5h2lx">
                      {b.items.map(item => <li key={item} className="rounded-full bg-cream px-3 py-1 text-sm font-bold text-navy" data-id="element-146" data-mp="2tpydel7h4cca">{item}</li>)}
                    </ul>}
                </div>
              </div>
            </li>)}
        </ol>

        <div className="mt-10 px-2" data-id="element-147" data-mp="1dchlnz8h7wpv">
          <CTAButton label="Yes, I want all 5 bonuses" data-id="element-148" data-mp="1dbg9frfq546k" />
        </div>
      </div>
    </section>;
}